import {AxiosResponse} from 'axios'

export const JWT_EXPIRED = 'JwtExpired'
export const NOT_CLOCKED_IN = 'NotClockedIn'
export const ROLE_MEMBERSHIP = 'InsufficientRoleMembership'
export const MISSING_TK_ASSIGNMENT = 'MissingTruckAssignment'
export const MISSING_AUTH = 'AuthorizationDenied'
export const ACCESS_DENIED = 'AccessDenied'
export const AUTH_DENIED = 'AuthorizationDenied'

export class ApiError {
    private _message: string = ''

    public constructor(
        public readonly statusCode: number, // this is 0 for client errors, like connection issues
        public readonly type: string,
        public readonly messages: Record<string, string>,
        public readonly stack: string[],
        public readonly response?: AxiosResponse,
        public readonly cause?: Record<string, any>
    ) {
    }

    public __toString(): string {
        return this.message
    }

    /* This is named to match the "message" property on most Error objects. This also avoids conflicting
     * with the H3 "messages" object.
     */
    public get message(): string {
        if (this._message) return this._message

        let messages = []

        for (let key in this.messages)
            messages.push(
                /\d+/.test(key)
                    ? this.messages[key]
                    : `(${key}) ${this.messages[key]}`
            )

        if (this.statusCode == 0) {
            let cause = this.cause ? ` ${this.cause}` : ''
            return `[${this.type}]: ${messages.join(', ')}${cause}`
        }

        return (this._message = `H3[${this.statusCode}] ${this.type}: ${messages.join(', ')}`)
    }

    public isRemoteError(): boolean {
        return this.statusCode >= 400
    }

    public isLocalError(): boolean {
        return this.statusCode == 0
    }

    public isValidationFailed() {
        return this.type === 'ValidationFailed'
    }

    public isConstraintViolation() {
        return this.type === 'ConstraintViolation'
    }

    public isInvalidArgument() {
        return this.type === 'InvalidArgument'
    }

    public isOutOfRange() {
        return this.type === 'OutOfRange'
    }

    public isInsufficientRoleMembership() {
        return this.type === 'InsufficientRoleMembership'
    }

    public isMissingTruckAssignment() {
        return this.type === 'MissingTruckAssignment'
    }

    public isNotClockedIn() {
        return this.type === 'NotClockedIn'
    }

    /** means truck assignment changed since h3 token was issued */
    public isUnsupportedTruckAssignment() {
        return this.type === 'UnsupportedTruckAssignment'
    }

    public isDriverError() {
        return this.type === 'DriverError'
    }

    public isNotFound() {
        return this.type === 'NotFound'
    }

    public isAccessDenied() {
        return this.type === 'AccessDenied'
    }

    public isAuthorizationDenied() {
        return this.type === 'AuthorizationDenied'
    }
}
